/*
 * Public API Surface of angular-validations
 */

export * from './lib/angular-validations.service';
export * from './lib/angular-validations.component';
export * from './lib/angular-validations.module';
